/**
 * Round Complete Screen — Score summary between rounds.
 */

import { getState, advanceRound } from '../game-state';
import { RoundNumber } from '../../shared/types';
import { navigate } from '../router';
import { t, getRoundName } from '../i18n';

export function renderRoundComplete(): void {
  const app = document.getElementById('app')!;
  const state = getState();
  const round = state.currentRound;
  const roundScore = state.roundScores[round];
  const maxRounds = state.settings.rounds;
  const isLastRound = round >= maxRounds;

  app.innerHTML = `
    <div class="stack center">
      <h1 style="font-size: var(--font-size-xl);">${t('roundComplete', round)}</h1>
      <p class="text-muted">"${getRoundName(round)}"</p>

      <!-- Round Score -->
      <div class="final-scores">
        <div class="final-score-team">
          <div class="score-label">${t('teamA')}</div>
          <div class="score-value">+${roundScore.A}</div>
        </div>
        <div class="final-score-team">
          <div class="score-label">${t('teamB')}</div>
          <div class="score-value">+${roundScore.B}</div>
        </div>
      </div>

      <!-- Cumulative Score -->
      <div class="score-bar">
        <div>
          <span class="team-label">${t('totalA')}</span>
          <span class="team-score">&nbsp;${state.scores.A}</span>
        </div>
        <div>
          <span class="team-score">${state.scores.B}&nbsp;</span>
          <span class="team-label">${t('totalB')}</span>
        </div>
      </div>

      <!-- Next Action -->
      <button class="btn btn-primary" id="btn-next-round">
        ${isLastRound ? t('seeFinalResults') : t('nextRound')}
      </button>
    </div>
  `;

  document.getElementById('btn-next-round')?.addEventListener('click', () => {
    advanceRound();
    const s = getState();
    if (s.phase === 'game-end') {
      navigate('game-end');
    } else {
      navigate('round-interstitial');
    }
  });
}
